export default function About() {
  return (
    <section id="about" className="py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <span className="text-gray-600 text-sm font-semibold tracking-[0.2em] uppercase">WHO WE ARE</span>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center mb-20">
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A1128] leading-tight">
              Protecting Your Digital Freedom Since Day One
            </h2>
            <p className="text-gray-700 text-lg leading-relaxed">
              IMPORMANZ S A S is dedicated to providing cutting-edge VPN solutions that empower individuals and businesses to browse the internet securely and privately. Based in Manizales, Colombia, we combine advanced encryption technology with user-friendly design to deliver a seamless privacy experience.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              Our mission is simple: to make online privacy accessible to everyone. We believe that internet freedom is a fundamental right, and we're committed to protecting your data from prying eyes, whether you're at home, at work, or on the go.
            </p>
          </div>

          <div className="relative h-96">
            <div className="absolute inset-0 bg-gradient-to-br from-[#00D9FF]/20 to-[#8B5CF6]/20 rounded-3xl transform rotate-3"></div>
            <div className="absolute inset-0 bg-gradient-to-tl from-[#8B5CF6]/20 to-[#00D9FF]/20 rounded-3xl transform -rotate-3"></div>
            <div className="absolute inset-4 bg-white rounded-3xl shadow-2xl flex items-center justify-center">
              <i className="ri-global-line text-9xl text-[#00D9FF]/30"></i>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-[#00D9FF]/10 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-shield-check-line text-3xl text-[#00D9FF]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#0A1128] mb-4">Security First</h3>
            <p className="text-gray-600 leading-relaxed">
              Military-grade encryption ensures your data remains private and secure from hackers, ISPs, and government surveillance.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-[#00D9FF]/10 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-lock-line text-3xl text-[#00D9FF]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#0A1128] mb-4">Zero Logs Policy</h3>
            <p className="text-gray-600 leading-relaxed">
              We don't track, collect, or store your online activity. Your privacy is your business, not ours.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-[#00D9FF]/10 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-earth-line text-3xl text-[#00D9FF]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#0A1128] mb-4">Global Access</h3>
            <p className="text-gray-600 leading-relaxed">
              Connect to servers worldwide and access content without restrictions, wherever you are.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
